import React, { Component } from 'react'
import { Modal } from 'hljd'
import { observer } from 'mobx-react'
import store from './store'
import styles from './style.module.less'

@observer
export default class extends Component {
  render() {
    const { visible, list } = store
    return (
      <Modal
        title="优秀商家简介示例"
        visible={visible}
        onCancel={store.showExample('')}
        footer={null}
      >
        {list.map(({ id, summary, merchant_name }) => (
          <div className={styles.item} key={id}>
            <p className={styles.title}>{merchant_name}：</p>
            <p className={styles.para}>{summary}</p>
          </div>
        ))}
      </Modal>
    )
  }
}
